import { inject } from '@angular/core';
import { CanMatchFn, Router, UrlTree } from '@angular/router';

/**
 * Member guest-only guard:
 * If member is logged in (auth_token exists) -> redirect to /member/dashboard
 * Else allow access.
 */
export const memberGuestGuard: CanMatchFn = (): boolean | UrlTree => {
    const router = inject(Router);

    const token = localStorage.getItem('auth_token');
    if (token) {
        return router.createUrlTree(['/member/dashboard']);
    }

    return true;
};